export default __webpack_public_path__ + "static/media/TheMixC5-5_Plain.9b071dca.woff2";